import { riskManagementResourceAdapter } from './RiskManagement.resource';
export function volumeIncreaseLiquidityMakerAdapter(data) {
    var _data$pair, _data$pair2;
    var broker = {
        id: data.account.broker.id,
        name: data.account.broker.name,
        separator: data.account.broker.separator,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var account = {
        id: data.account.id,
        name: data.account.name,
        key: data.account.key,
        secret: data.account.secret,
        passphrase: data.account.passphrase,
        broker: broker,
        pair: data.account.pair,
        main: data.account.main,
        client: data.account.client,
        type: data.account.type,
        mainAccount: data.account.mainAccount
    };
    var priceStep = {
        type: data.priceStep.type,
        bid: data.priceStep.bid,
        asc: data.priceStep.asc
    };
    var sumStep = {
        type: data.sumStep.type,
        bid: data.sumStep.bid,
        asc: data.sumStep.asc
    };
    var pair = {
        id: data.pair.id,
        name: data.pair.name,
        baseCurrency: (_data$pair = data.pair) === null || _data$pair === void 0 ? void 0 : _data$pair.baseCurrency,
        quoteCurrency: (_data$pair2 = data.pair) === null || _data$pair2 === void 0 ? void 0 : _data$pair2.quoteCurrency,
        maxSum: data.pair.maxSum,
        broker: broker,
        restartMaxTimeValue: data.pair.restartMaxTimeValue,
        minQuantity: data.pair.minQuantity
    };
    var riskManagement = riskManagementResourceAdapter(data.riskManagement);
    return {
        id: data.id,
        countOrderBid: data.countOrderBid,
        countOrderAsc: data.countOrderAsc,
        active: data.active,
        startedAt: data.startedAt,
        useWebSocket: data.useWebSocket,
        statuses: data.statuses,
        account: account,
        priceStep: priceStep,
        sumStep: sumStep,
        pair: pair,
        multiplier: data.multiplier,
        filledOrdersBuy: data.filledOrdersBuy,
        percentageDown: data.percentageDown,
        percentageUp: data.percentageUp,
        percentageStep: data.percentageStep,
        hedging: data.hedging,
        riskManagement: riskManagement
    };
}
